<template>
	<div class="container">
		<div class="container__content">
			<router-view />
		</div>
	</div>
</template>

<script>
export default {
	name: 'container'
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/mq';

.container {
	height: 100vh;
	overflow-x: hidden;
	overflow-y: scroll;
	background-color: $grey-95;
	padding: 0 1rem;

	&__content {
		position: relative;
		width: 100%;
		max-width: 1440px;
		min-height: calc(100% - 2rem);
		margin: 1rem auto;
	}

	@include mq(md) {
		padding: 0 3rem;

		&__content {
			min-height: calc(100% - 6rem);
			margin: 3rem auto;
		}
	}
}
</style>
